<template>
  <van-tabbar 
    v-model="active" 
    placeholder
    :border="false"
    active-color="#B9EC66"
    inactive-color="#7D8E80"
    :before-change="handleChange"
  >
    <van-tabbar-item replace to="/">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? icon.active : icon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>质押记录</span>
      <template #icon="props">
        <img :src="props.active ? icon1.active : icon1.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>NFT</span>
      <template #icon="props">
        <img :src="props.active ? icon2.active : icon2.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>SUPERAPP</span>
      <template #icon="props">
        <img :src="props.active ? icon3.active : icon3.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/mine">
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? icon4.active : icon4.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup>
  import { ref, watch } from 'vue'
  import { useRoute } from "vue-router"
  import { showToast } from 'vant'

  const route = useRoute()
  const active = ref(0)
  switch (route.path) {
    case '/':
      active.value = 0
      break;
    case '/mine':
      active.value = 4
      break;
  }

  function handleChange(val) {
    if(val !== 0 && val !== 4) {
      showToast('暂未开放')
    } else {
      return true
    }
  }

  const icon = {
    active: require('@/assets/img/icon_home_active.png'),
    inactive: require('@/assets/img/icon_home.png'),
  }
  const icon1 = {
    active: require('@/assets/img/icon_record_active.png'),
    inactive: require('@/assets/img/icon_record.png'),
  }
  const icon2 = {
    active: require('@/assets/img/icon_nft_active.png'),
    inactive: require('@/assets/img/icon_nft.png'),
  }
  const icon3 = {
    active: require('@/assets/img/icon_app_active.png'),
    inactive: require('@/assets/img/icon_app.png'),
  }
  const icon4 = {
    active: require('@/assets/img/icon_mine_active.png'),
    inactive: require('@/assets/img/icon_mine.png'),
  }
</script>
<style scoped lang="less">
:deep(.van-tabbar){
  background: url("@/assets/img/tabbar_bg.png") no-repeat;
  background-size: 100% auto;

  .van-tabbar-item--active{
    background: transparent;
  }

  .van-tabbar-item__text span{
    font-size: 10px;
  }
}
</style>